// 3. 가맹점 관리 > 3.1 가맹점 목록 > 3.1.1 가맹점 상세

import { observer } from "mobx-react";
import React, { startTransition, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { ChevronLeft } from "@/components/icons/chevron";

import colors from "@/design/colors";
import fonts from "@/design/typography";

import BasicInfoTab from "./tabs/BasicInfoTab";
import Tab from "@/components/tab/Tab";
import CatTab from "./tabs/CatTab/CatTab";
import Device from "./tabs/DeviceTab/Device";

const DetailFrnachise = observer(() => {
  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const navigate = useNavigate();

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
  const [activeTab, setActiveTab] = useState<string>("basicInfo"); // 활성화된 탭
  

  /* **********************************
   * USEHOOK
   * 데이터 처리
   ********************************** */

  /* **********************************
   * HOOKS
   ********************************** */



  /* **********************************
   * Element
   ********************************** */

  return (
    <Container>
      <section
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "48px",
        }}
      >
        {/* 타이틀 */}
        <span
          style={{
            ...fonts.title2SemiBold,
            color: colors.gray900,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            marginTop: "2px",
          }}
          onClick={() => {
            startTransition(() => navigate("/payment/franchise-list"));
          }}
        >
          <ChevronLeft
            style={{ width: "24px", height: "31px", marginRight: "8px" }}
          />
          <Title>가맹점 정보</Title>
        </span>
      </section>
        <Tab 
          tabs={[
            {
              key: "basicInfo",
              label: "기본정보",
              content: <BasicInfoTab/>
            },{
              key: "cat",
              label: "전체 CAT ID",
              content: <CatTab />
            },{
              key: "device",
              label: "기기",
              content: <Device/>
            }
          ]}
          activeKey={activeTab}
          onChange={setActiveTab}
        />
    </Container>
  );
});

/* **********************************
 * Style
 * 스타일 처리
 ********************************** */
const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 40px 40px 40px;
  overflow-y: auto;

  ${({ theme }) => theme.device.mobile} {
    padding: 10px 20px 20px 20px;
  }
`;

const Title = styled.span`
  font-family: ${fonts.title2SemiBold.fontFamily};
  font-size: ${fonts.title2SemiBold.fontSize};
  line-height: ${fonts.title2SemiBold.lineHeight};
  color: ${colors.gray900};

  ${({ theme }) => theme.device.mobile} {
    font-size: 1rem;
  }
`;

export default DetailFrnachise;
